<template>
    <Attr :widget_id="widget_id" :attr_id="attr_id">
       <div class="attr-tab-panel">
            <!-- pinnedHeader: вкладка-шапка рендерится НАД панелью вкладок и остаётся
                 видимой при переключении вкладок (реквизиты документа мульти-гридом) -->
            <div v-if="pinnedTabs.length" class="tab-panel-pinned">
                <component v-for="pt in pinnedTabs" :key="pt.html_id || pt.name"
                    :widget_id="widget_id"
                    :is="pt.component"
                    :attr_id="pt.id"
                    v-bind="tabBindings(pt)"
                />
            </div>
            <wj-tab-panel
                :class="[attr?.cssClass]"
                :initialized="initialized"
                :selectedIndexChanged="selectedIndexChanged"
                :refreshed="refreshed"
                :gotFocus="gotFocus"
                :lostFocus="lostFocus"
                :isAnimated=false
            >
                <wj-tab v-for="(attrTab, indTab) in tabAttrs" :key="attrTab.html_id || `tab${indTab}`" :isVisible="isTabVisible(attrTab)">
                    <!-- IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): у вкладки из props (localTabs) — ключ объяснения по Alt (data-help, как у v-uiHelp; объяснение даёт tabTooltipFn) -->
                    <a v-wjTooltipFn="tabTooltipFn(attrTab)" :data-help="localTabs_on() && attrTab.help ? attrTab.help.key : null">
                        <!-- IE 2026 11 03 / ODOO-350449 (heatmap tab s134): иконка и подпись вкладок теплокарты — с фронта (tabPi / tabTip / tabTitle), записи без пересева несут старые -->
                        <i v-if="tabPi(attrTab)" :class="tabPi(attrTab)"></i>
                        <span hidden :data-mob-title="tabTip(attrTab) || tabTitle(attrTab) || ''"></span>
                        {{ tabTitle(attrTab) }}
                        <!-- IE 2026 09 21 / ODOO-5800 (замечание Игоря: красный бейдж вкладки Metrics — строки с grade = bad): есть статистика с оценкой Bad —
                             вместо числа строк таблицы вкладки красный бейдж с числом строк данных с плохими метриками (сумма колонки Rows по строкам Bad) -->
                        <div class="badge badge-bad" v-if="metricsBad(attrTab)" :title="metricsBad(attrTab).title" v-uiHelp="'widget.tabs.metricsBad'">{{ store?.formatCount(metricsBad(attrTab).rows) }}</div>
                        <div class="badge" v-else-if="attrTab.countItems && !attrTab['hide-countItems']" v-uiHelp="'widget.tabs.count'">{{ store?.formatCount(attrTab.countItems) }}</div>
                        <!-- IE 2026 10 12 / ODOO-345618 (заказ Игоря: бейдж согласования на вкладке вместо чипса): бейдж вкладки Approval «ждут согласования / все единицы на согласование» из чипса сводки; наведение — текст чипса; при просроченных / возвращённых мне — цвет чипса status. Выключатель fe.ux.approvalTabBadge -->
                        <!-- IE 2026 10 12 / ODOO-345618 (заказ Игоря: бейдж согласования на вкладке вместо чипса) (проба AB1): :title уносит v-uiHelp в aria-label — текст чипса показывает Alt-карточка (vars.chip, строка «Now») -->
                        <!-- IE 2026 10 13 / ODOO-5800: бейдж по строкам отчёта — состояния rowsNormal / rowsStatus подсказки (approvalBadgeState) -->
                        <div class="badge badge-approval" :class="{ 'badge-approval-status': approvalBadge(attrTab).css === 'status' }" v-if="approvalBadge(attrTab)" v-uiHelp="{ key: 'widget.tabs.approvalBadge', state: () => approvalBadgeState(attrTab), vars: () => ({ chip: approvalBadge(attrTab)?.title || '', rows: approvalBadge(attrTab)?.scope?.rows ?? '', units: approvalBadge(attrTab)?.scope?.units ?? '' }) }">{{ approvalBadge(attrTab).text }}</div>
                        <!-- IE 2026 09 08 / ODOO-335246 (Igor): бейдж-птичка, если флаг записи по badgeBinding установлен (MV: Create materialized view; Calculation cascade: Use in calculation cascade) -->
                        <!-- IE 2026 09 08 / ODOO-335246 (Igor): badgeStateBinding === 'dirty' → жёлто-коричневый бейдж (грязные узлы каскада на источниках записи) -->
                        <!-- IE 2026 09 12 / ODOO-335246 (Igor): цвет бейджа по badgeLevelBinding: on — белый (участвует в чьём-то каскаде), use — жёлтый, auto — зелёный -->
                        <!-- IE 2026 09 23 / ODOO-341407: i18n -->
                        <div class="badge badge-check" :class="{'badge-dirty': badgeDirty(attrTab), 'badge-lvl-on': badgeLevel(attrTab) === 'on', 'badge-lvl-use': badgeLevel(attrTab) === 'use', 'badge-lvl-auto': badgeLevel(attrTab) === 'auto'}" v-if="attrTab.badgeBinding && (!!store.get_value(WIDGET?.record, attrTab.badgeBinding) || badgeDirty(attrTab))" :title="badgeDirty(attrTab) ? (attrTab.badgeDirtyTitle || t('Calculation cascade: dirty nodes in the sources — the data may be stale')) : badgeLevelTitle(attrTab)" v-uiHelp="{ key: 'widget.tabs.flag', state: () => (badgeDirty(attrTab) ? 'dirty' : (badgeLevel(attrTab) || 'flag')) }">{{ attrTab.badge || '✓' }}</div>
                    </a>
                    <div>
                        <!-- R13 (#77.1, lazyTabs): невидимая вкладка не монтирует содержимое —
                             компонент создаётся при первой активации (openedTabs) -->
                        <component
                            v-if="!localTabs_on() && tabRendered(indTab)"
                            :widget_id="widget_id"
                            :is="attrTab.component"
                            :attr_id="attrTab.id"
                            v-bind="tabBindings(attrTab)"
                        />
                        <!-- IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): вкладки из props — содержимое вкладки даёт владелец слотом tab-<name> (обе вкладки сразу, без ленивого монтирования) -->
                        <slot v-if="localTabs_on()" :name="'tab-' + attrTab.name"></slot>
                    </div>
                </wj-tab>
            </wj-tab-panel>
        </div>
    </Attr>
</template>

<script>
import { useMainStore } from '@/stores/mainStore'
import { uiHelp_rowsHtml, uiHelp_enabled } from '@/utils/uiHelp'   // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U3
import { uiHelp_html } from '@/utils/uiHelp'   // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): объяснение вкладки из props своим ключом
import { tabsLazy_on, tabsLazy_count } from '@/utils/tabsLazy'   // IE 2026 09 26 / ODOO-5800: выключенные вкладки фоном не монтируются (fe.ux.tabsLazyHidden)
import { rowCard_paramsTabIndex, rowCard_shouldApply } from '@/utils/rowCardTab'   // IE 2026 10 24 / ODOO-348842 (заказ Игоря: карточка строки открывается на вкладке ⚙ Params)
import { editCommit_pending } from '@/utils/editCommit'   // IE 2026 10 14 / ODOO-345813 (заказ Игоря: окна остановок регламента): открытый редактор ячейки формы закрывается ДО запроса ленивой вкладки (Preview)
import { lazyTab_canSend, lazyTab_gridAttrs, lazyTab_recovery, lazyTab_revealTargets, lazyTabReveal_on } from '@/utils/lazyTabReveal'   // IE 2026 10 16 / ODOO-5800: ленивая вкладка — один запрос в пути, грид чинится после данных
import { approvalDoc as _apDoc } from '@/utils/approval'   // IE 2026 10 11 / ODOO-345618 (заказ Игоря: согласование под ключ) — FE3: вкладка «Approval» отчёта
import { t as _apT } from '@/i18n'   // IE 2026 10 11 / ODOO-345618 (заказ Игоря: согласование под ключ) — FE3
import { approvalTabBadge, approvalTabBadgeOn, approvalTabBadgeScopedOn } from '@/utils/approval'   // IE 2026 10 12 / ODOO-345618 (заказ Игоря: бейдж согласования на вкладке вместо чипса)
import { DISPLAY_TAB, displayTab_on, displayCtx_ofRow, displayOptions_forCtx } from '@/utils/displayOptions'   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: все варианты отображения — во вкладке Display шестерёнки, не на форме)
import { displayDock_on, displayDock_apply, displayDock_isDocked } from '@/utils/displayTabDock'   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р5): вкладка Display — окно формы узкой полосой справа, грид виден
import { pmHistory_slimFields } from '@/utils/pmHistory'   // IE 2026 10 29 / ODOO-5800 (ie-dm7 r62 #115629: D1): первый запрос вкладки истории — без view отчёта
import { HEATMAP_GRID_TAB, heatmapGridTab_on, HEATMAP_OLD_TAB, heatmapOldTab_hide, heatmapGridTab_use, heatmapTab_redirectIndex, heatmapTab_decor } from '@/utils/heatmapGrid'   // IE 2026 11 03 / ODOO-350449 (heatmap tab s134) + heatmapTab_redirectIndex, heatmapTab_decor   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: теплова карта на базі таблиці — порівняльна вкладка)   // IE 2026 11 03 / ODOO-350449 (heatmap tab swap)   // IE 2026 11 03 / ODOO-350449 (webscm review): + heatmapOldTab_hide
import { guideCases_tabHidden } from '@/utils/guideCases'   // IE 2026 09 28 / ODOO-342342 (Use cases): вкладка формы-меню кейсов прячется при выключенном fe.guide.cases
import { adf_tableChanged } from '@/utils/auditDiff'   // IE 2026 10 31 / ODOO-349799 (заказ Игоря: переход ‹ › по изменениям аудита): вкладка ТЧ с изменениями не прячется предварительной проверкой

export default {
    props: [
        'widget_id',
        'attr_id',
        'parent_type',
        // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды — «для построения табов используй нашу компоненту AttrTabPanel»): ВКЛАДКИ ИЗ PROPS —
        // панель без attr в реестре виджета (окно легенды графика): localTabs — [{ name, title, html_id?, pi?, tooltip?, help?: { key, state? } }], содержимое
        // вкладки — слот владельца tab-<name>, выбранная — localSelected (name), выбор пользователя — событие local-select (name). В этом режиме панель attr
        // виджета не ищет и виджет не трогает: память вкладок (WIDGET._activeTabByPanel), activeTab / selectTab / layoutTab, заглушки формы настроек,
        // guideCases, предпроверка пустых и ленивое монтирование вкладок, перечитывания Ганта / печати / лога / Versions, ресайз виджета — не участвуют.
        // Без localTabs — всё как было
        'localTabs',
        'localSelected',
    ],
    emits: ['local-select'],   // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): выбор вкладки из props пользователем
    data: () => ({
        WIDGET: {},
        // attr присваивается позже (widget_attr_set) — объявлен, чтобы был
        // реактивным и не сыпал Vue-warn «accessed during render but not defined»
        attr: null,
        // R13 (lazyTabs): индексы вкладок, которые уже активировались — только они
        // смонтированы; первая (или запрошенная) вкладка помечается в initialized/
        // selectedIndexChanged
        openedTabs: { 0: true },
    }),
    setup() {
        const store = useMainStore();
        return { store }
    },
    created() {
        if (this.localTabs_on()) { this.WIDGET = null; return }   // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): вкладки из props — ни attr виджета, ни предпроверки
        // console.log(`created ${this.attr_id}`)
        this.WIDGET = this.store.findWidget(this.widget_id).WIDGET
        this.content_Changed()
        this.tabsPrecheck()   // IE 2026 09 06 / ODOO-336330: пустые по данным вкладки не показывать в первом кадре
        // IE 2026 09 26 / ODOO-5800 (fe.ux.tabsLazyHidden): первая вкладка ВЫКЛЮЧЕНА — не монтировать её «по умолчанию» (openedTabs {0}): её не видно,
        // wijmo выберет первую видимую, а она смонтируется в initialized
        if (this.tabsLazy_skip(0)) delete this.openedTabs[0]
    },
    beforeUnmount() {
        // R13: остановить фоновое домонтирование вкладок
        this._unmounted = true   // IE 2026 08 30 / ODOO-5800: порционный домонтаж прекращает работу
        if (this._dispTab && displayDock_isDocked(this.WIDGET)) displayDock_apply(this.store, this.WIDGET, false)   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р5): панель снимается — окну формы прежний рект
        if (this._lazyMountTimer) {
            clearTimeout(this._lazyMountTimer)
            clearInterval(this._lazyMountTimer)
            this._lazyMountTimer = null
        }
        if (this._lazyMountIdle && typeof window !== 'undefined' && window.cancelIdleCallback) {
            window.cancelIdleCallback(this._lazyMountIdle)
            this._lazyMountIdle = null
        }
    },
    methods: {
        // IE 2026 09 21 / ODOO-5800 (замечание Игоря: красный бейдж вкладки Metrics — строки с grade = bad). Вкладка Metrics (бэк
        // _MetricsTabMixin.append_metrics_tab: name 'tab-metrics', строки record._doc.metrics_stats приходят с данными виджета — вкладку открывать не нужно).
        // Число — сумма Rows по строкам статистики с Grade = Bad: его можно проверить глазами по таблице вкладки (строка данных с несколькими плохими
        // метриками входит в каждую из них). Нет плохих — обычный бейдж. Выключатель fe.ux.metricsTabBadBadge
        metricsBad(attrTab) {
            if (!attrTab || (attrTab.name !== 'tab-metrics' && attrTab.lazyBinding !== '_doc.metrics_stats')) return null
            const stats = this.WIDGET?.record?._doc?.metrics_stats
            if (!Array.isArray(stats) || !stats.length) return null
            if (this.store.setting('fe.ux.metricsTabBadBadge', true) === false) return null
            let rows = 0, lines = 0
            for (const st of stats) {
                if (!st || String(st.grade ?? '').trim().toLowerCase() !== 'bad') continue
                const n = Number(st.rows) || 0
                if (n > 0) { lines++; rows += n }
            }
            // IE 2026 09 21 / ODOO-5800: бэк ie-dm7 6ebece310 отдаёт итог РАЗНЫХ строк по оценкам (record._doc.metrics_stats_summary.by_grade) — точное число строк
            // с Bad; поля нет (бой до выкладки бэка, старый бэк) — прежняя сумма колонки Rows, где строка с несколькими плохими метриками считается в каждой
            const byGrade = this.WIDGET?.record?._doc?.metrics_stats_summary?.by_grade
            if (byGrade && typeof byGrade === 'object') {
                let exact = 0
                for (const g of Object.keys(byGrade)) if (String(g).trim().toLowerCase() === 'bad') exact += Number(byGrade[g]) || 0
                if (!exact) return null
                // IE 2026 09 23 / ODOO-341407: i18n: плюрал через tn
                return { rows: exact, lines, exact: true, title: this.t('Bad metrics: {rows}', { rows: this.tn(exact, '{n} row', '{n} rows') }) + (lines ? ' (' + this.tn(lines, '{n} metric line', '{n} metric lines') + ')' : '') }
            }
            if (!rows) return null
            return { rows, lines, title: this.t('Bad metrics: {rows} in {lines}', { rows: this.tn(rows, '{n} row', '{n} rows'), lines: this.tn(lines, '{n} metric line', '{n} metric lines') })
                + (lines > 1 ? ' ' + this.t('(a row with several Bad metrics is counted in each line)') : '') }
        },
        // IE 2026 09 12 / ODOO-335246 (Igor): уровень бейджа (on / use / auto) — по badgeLevelBinding записи
        badgeLevel(attrTab) {
            // вид виджета, сохранённого на столе раньше, привязки уровня не несёт — для бейджа вкладки каскада она известна
            const b = attrTab?.badgeLevelBinding || (attrTab?.badgeBinding === '_doc.cascade_tab_badge' ? '_doc.cascade_tab_level' : '')
            try { return b ? String(this.store.get_value(this.WIDGET?.record, b) || '') : '' } catch (e) { return '' }
        },
        badgeLevelTitle(attrTab) {
            const l = this.badgeLevel(attrTab)
            // IE 2026 09 23 / ODOO-341407: i18n
            if (l === 'auto') return this.t('Run automatically in the cascade is on')
            if (l === 'use') return this.t('Use in calculation cascade is on')
            if (l === 'on') return this.t('Takes part in a calculation cascade (its sources are under a cascade)')
            return attrTab?.badgeTitle || ''
        },
        // IE 2026 09 08 / ODOO-335246 (Igor): бейдж вкладки в состоянии «грязно» — по badgeStateBinding записи ('dirty')
        badgeDirty(attrTab) {
            try { return !!attrTab?.badgeStateBinding && this.store.get_value(this.WIDGET?.record, attrTab.badgeStateBinding) === 'dirty' }
            catch (e) { return false }
        },
        content_Changed() {
            this.store.widget_attr_set(this)
            // attr не выставился — виджета нет в сторе (стол пересоздан при смене
            // процессной модели): дальше идти нельзя, дальше всё через this.attr
            if (!this.attr) return
            if (this.tabPanel) {
                // // 1) пробуем восстановить из кэша selectedIndex
                // const cached = this.store.vueObjCache[this.cacheKey]
                // if (cached && 'selectedIndex' in cached && this.tabPanel.selectedIndex !== cached.selectedIndex) {
                //     // console.log(`AttrTabPanel: restore cached selectedIndex=${cached.selectedIndex} for ${this.cacheKey}`)
                //     this.tabPanel.selectedIndex = cached.selectedIndex
                // }

                this._explicitTab = false   // IE 2026 09 10 / ODOO-…
                if (this.attr.selectedIndex != null) {
                    // IE 2026 09 25 / ODOO-341407 (№17): метка источника — вкладка вида с бэка (set_viewParams: Active tab, пусто — tabSheet);
                    // стартовая вкладка ответа (WIDGET.activeTab) её перебивает, selectTab / layoutTab (true) и клик пользователя — нет
                    this._explicitTab = 'attr'   // IE 2026 09 10 / ODOO-… (было true; значение по-прежнему truthy для проверок ниже)
                    this.attr.selectedIndex = this.tabIdx_fix(this.attr.selectedIndex)   // IE 2026 11 03 / ODOO-350449 (heatmap tab s134): Active tab = скрытая старая вкладка Heatmap — таблица, а не первая видимая (List)
                    this._intendedIndex = this.attr.selectedIndex   // IE 2026 09 06 / ODOO-336330: задуманная вкладка — для selection_restore
                    const _live = this.liveTab_index()   // IE 2026 10 12 / ODOO-345618 (заказ Игоря: активная вкладка после перечитки): перечитка отчёта несёт вкладку вида по умолчанию (attr.selectedIndex) — живая вкладка панели остаётся, если она есть и в новом наборе
                    if (_live >= 0) {   // IE 2026 10 12 / ODOO-345618 (заказ Игоря: активная вкладка после перечитки)
                        this._intendedIndex = _live   // IE 2026 10 12 / ODOO-345618 (заказ Игоря: активная вкладка после перечитки)
                        if (this.tabPanel.selectedIndex !== _live) this.tabPanel.selectedIndex = _live   // IE 2026 10 12 / ODOO-345618 (заказ Игоря: активная вкладка после перечитки)
                        if (typeof window !== 'undefined') window.__keepActiveTab = (window.__keepActiveTab || 0) + 1   // IE 2026 10 12 / ODOO-345618 (заказ Игоря: активная вкладка после перечитки): счётчик
                    } else if (this.tabPanel.selectedIndex !== this.attr.selectedIndex) {   // IE 2026 10 12 / ODOO-345618 (заказ Игоря: активная вкладка после перечитки)
                        this.tabPanel.selectedIndex = this.attr.selectedIndex
                    }
                    delete this.attr.selectedIndex
                }

                // запрошенная при открытии виджета вкладка (widget_open selectTab):
                // активируем по name и сбрасываем метку
                if (this.WIDGET?.selectTab) {
                    const idx = this.tabAttrs.findIndex(t => t?.name === this.WIDGET.selectTab)
                    if (idx >= 0) {
                        this._intendedIndex = idx   // IE 2026 09 06 / ODOO-336330
                        if (this.tabPanel.selectedIndex !== idx) {
                            this.tabPanel.selectedIndex = idx
                        }
                        delete this.WIDGET.selectTab
                        this._explicitTab = true   // IE 2026 09 10 / ODOO-…
                    }
                }
                // IE 2026 09 11 / ODOO-… (заказ Игоря): вкладка из сохранённой раскладки страницы (Widgets → Save as my / Save for all → layout.tab)
                // — у главной панели виджета (attr из WIDGET.view), один раз при открытии; дальше вкладку ведут пользователь
                // и _activeTabByPanel. Вкладка ищется по name, затем title, tooltip, якорю (tabFind)
                if (!this._userSelected && this.WIDGET?.layoutTab && (this.WIDGET.view || []).some(a => a?.id != null && a.id === this.attr?.id)) {
                    const idx = this.tabIdx_fix(this.tabFind(this.WIDGET.layoutTab))   // IE 2026 11 03 / ODOO-350449 (heatmap tab s134)
                    if (idx >= 0) {
                        this._intendedIndex = idx
                        if (this.tabPanel.selectedIndex !== idx) this.tabPanel.selectedIndex = idx
                        this._explicitTab = true
                    }
                    delete this.WIDGET.layoutTab
                }
                this.activeTab_apply()   // IE 2026 09 25 / ODOO-341407 (№17): вкладка, заданная бэком при открытии (WIDGET.activeTab)
                this.rowCard_defaultTab()   // IE 2026 10 24 / ODOO-348842 (заказ Игоря: карточка строки открывается на вкладке ⚙ Params)
                // IE 2026 09 10 / ODOO-… (замечание Игоря): виджет перенесён на другую страницу (drag на страницу) — там монтируется
                // НОВЫЙ экземпляр панели, и вкладка сбрасывалась на первую. Живая вкладка каждой панели хранится в
                // WIDGET._activeTabByPanel[attr.name] (tabKeep_record) и восстанавливается, пока в этом экземпляре
                // пользователь не кликал по вкладкам и вкладка не задана явно (attr.selectedIndex / selectTab)
                if (!this._explicitTab && !this._userSelected) {
                    const _keep = this.tabIdx_fix(this.WIDGET?._activeTabByPanel?.[this.tabKeep_key()] ?? -1)   // IE 2026 11 03 / ODOO-350449 (heatmap tab s134)
                    if (_keep != null && _keep >= 0 && _keep < (this.tabAttrs?.length || 0) && this.tabPanel.selectedIndex !== _keep) {
                        this._intendedIndex = _keep
                        this.tabPanel.selectedIndex = _keep
                    }
                }
            }
        },
        // IE 2026 10 24 / ODOO-348842 (заказ Игоря): карточка строки табличной части (widget-row) открывается на вкладке ⚙ «Params» команды строки, если она есть.
        // Правило: запомненная вкладка (тот же экземпляр панели) остаётся как сейчас; запомненной вкладки нет — ⚙ (если её нет, прежнее: индекс 0): первое открытие, повторное
        // открытие после ✕ / Esc (метка W._rowCardTabReset от стора) и панель, созданная заново при ‹ › к строке другой команды (экземпляр новый — _rowCardSeen пуст).
        // Одна и та же команда (‹ › / клик по строке) — экземпляр прежний, вкладка не трогается. Явные источники (selectTab, раскладка, клик из колонки-вложенного грида)
        // и выбор пользователя в этом экземпляре важнее. Выключатель fe.ux.rowCardParamsTab (дефолт вкл.; выкл — вкладка 🏠 как прежде)
        rowCardTab_on() { return this.store.setting('fe.ux.rowCardParamsTab', true) !== false },   // IE 2026 10 24 / ODOO-348842
        rowCard_defaultTab() {   // IE 2026 10 24 / ODOO-348842
            const W = this.WIDGET, tp = this.tabPanel   // IE 2026 10 24 / ODOO-348842
            if (!tp || this._unmounted || !this.attr || !W || this.localTabs_on() || W.widget !== 'widget-row') return   // IE 2026 10 24 / ODOO-348842
            const main = (W.view || []).some(a => a?.id != null && a.id === this.attr.id)   // IE 2026 10 24 / ODOO-348842
            if (!main) return   // IE 2026 10 24 / ODOO-348842
            const reset = !!W._rowCardTabReset, fresh = !this._rowCardSeen   // IE 2026 10 24 / ODOO-348842
            if (!rowCard_shouldApply({ fresh, reset })) return   // IE 2026 10 24 / ODOO-348842
            this._rowCardSeen = true   // IE 2026 10 24 / ODOO-348842
            if (reset) delete W._rowCardTabReset   // IE 2026 10 24 / ODOO-348842
            if (!this.rowCardTab_on()) return   // IE 2026 10 24 / ODOO-348842
            if (this._explicitTab && this._explicitTab !== 'attr') return   // IE 2026 10 24 / ODOO-348842: selectTab / раскладка / activeTab от бэка уже выбрали вкладку
            if (reset) {   // IE 2026 10 24 / ODOO-348842: новое открытие карточки — выбор и память вкладок прежней карточки не в счёт
                this._userSelected = false   // IE 2026 10 24 / ODOO-348842
                this._liveTabKey = null   // IE 2026 10 24 / ODOO-348842
                if (W._activeTabByPanel) delete W._activeTabByPanel[this.tabKeep_key()]   // IE 2026 10 24 / ODOO-348842
            }
            if (this._userSelected) return   // IE 2026 10 24 / ODOO-348842
            const idx = rowCard_paramsTabIndex(this.tabAttrs, {   // IE 2026 10 24 / ODOO-348842
                widget: W.widget, metaType: W.record?._meta?.type, mainPanel: main, hasCommand: !!W.record?._record?.calculationModel,   // IE 2026 10 24 / ODOO-348842
                activeAttr: W.parentAction?.activeAttr?.binding, anchorKey: (t) => this.tabAnchorKey(t), isVisible: (t) => this.isTabVisible(t),   // IE 2026 10 24 / ODOO-348842
            })   // IE 2026 10 24 / ODOO-348842
            if (idx < 0) return   // IE 2026 10 24 / ODOO-348842: вкладки ⚙ нет — поведение прежнее
            this._intendedIndex = idx   // IE 2026 10 24 / ODOO-348842: selection_restore вернёт её, если wijmo уведёт выбор, пока вкладки перестраиваются
            if (tp.selectedIndex !== idx) tp.selectedIndex = idx   // IE 2026 10 24 / ODOO-348842
            this._explicitTab = 'rowCard'   // IE 2026 10 24 / ODOO-348842: восстановление из _activeTabByPanel ниже её не двигает
        },   // IE 2026 10 24 / ODOO-348842
        activeTab_apply() {
            // IE 2026 09 25 / ODOO-341407 (№17): бэк задаёт стартовую вкладку ответом widget_open — WIDGET.activeTab (widget_LIST:
            // новый список без источника → 'tabSource'), а фронт её не читал: лист открывался на первой вкладке. Применяется у главной
            // панели виджета (attr из WIDGET.view), один раз. Перебивает вкладку вида по умолчанию (attr.selectedIndex от set_viewParams —
            // её бэк ставит каждому листу, «Active tab» пусто → tabSheet: прогон dev02 25.09 показал, что иначе activeTab не срабатывает
            // никогда); явный запрос selectTab, раскладка layoutTab и клик пользователя по вкладкам важнее — тогда метка просто снимается.
            // Вызов — из content_Changed и при позднем приходе метки (watch)
            const W = this.WIDGET, tp = this.tabPanel
            if (!tp || this._unmounted || !W?.activeTab || !this.attr) return
            if (!(W.view || []).some(a => a?.id != null && a.id === this.attr.id)) return
            if ((!this._explicitTab || this._explicitTab === 'attr') && !this._userSelected) {
                const idx = this.tabIdx_fix(this.tabFind(W.activeTab))   // IE 2026 11 03 / ODOO-350449 (heatmap tab s134)
                if (idx >= 0) {
                    this._intendedIndex = idx   // selection_restore вернёт её, если wijmo уведёт выбор, пока вкладка спрятана
                    if (tp.selectedIndex !== idx) tp.selectedIndex = idx
                    this._explicitTab = 'activeTab'
                }
            }
            delete W.activeTab
        },
        selectTab_set(idx) {   // IE 2026 10 30 / ODOO-349799: бэк (updateDoc.selectTab) выбирает вкладку — как клик пользователя: selection_restore и activeTab_apply её не перебивают
            const tp = this.tabPanel   // IE 2026 10 30 / ODOO-349799
            if (!tp || this._unmounted || this.localTabs_on() || !(idx >= 0)) return false   // IE 2026 10 30 / ODOO-349799
            this._intendedIndex = idx   // IE 2026 10 30 / ODOO-349799
            this._userSelected = true   // IE 2026 10 30 / ODOO-349799
            this._explicitTab = 'selectTab'   // IE 2026 10 30 / ODOO-349799
            if (tp.selectedIndex !== idx) tp.selectedIndex = idx   // IE 2026 10 30 / ODOO-349799
            this.tabKeep_record(tp)   // IE 2026 10 30 / ODOO-349799
            return true   // IE 2026 10 30 / ODOO-349799
        },   // IE 2026 10 30 / ODOO-349799
        tabFind(ident) {
            // IE 2026 09 11 / ODOO-…: вкладка по идентификатору сохранённой раскладки — name, затем title, tooltip, затем якорь (tabAnchorKey)
            const tabs = this.tabAttrs || []
            let idx = tabs.findIndex(t => t?.name && t.name === ident)
            if (idx < 0) idx = tabs.findIndex(t => t?.title && t.title === ident)
            if (idx < 0) idx = tabs.findIndex(t => t?.tooltip && t.tooltip === ident)
            if (idx < 0) idx = tabs.findIndex(t => this.tabAnchorKey(t) === ident)
            return idx
        },
        tabKeep_key() {
            // IE 2026 09 10 / ODOO-…: ключ панели в WIDGET._activeTabByPanel — name/binding attr, а у главной панели виджета attr без name:
            // ключ по составу вкладок (одинаков у нового экземпляра той же панели)
            const a = this.attr
            if (!a) return ''
            if (a.name || a.binding) return a.name || a.binding
            return '~' + (this.tabAttrs || []).map(t => t?.name || t?.title || '').join('|')
        },
        tabKeep_record(tabPanel) {
            // IE 2026 09 10 / ODOO-…: запомнить живую вкладку панели (после инициализации — стартовые события wijmo не в счёт)
            if (!this._initDone || !this.WIDGET || !tabPanel) return
            const key = this.tabKeep_key()
            const idx = tabPanel.selectedIndex
            if (!key || idx == null || idx < 0) return
            const map = this.WIDGET._activeTabByPanel || (this.WIDGET._activeTabByPanel = {})
            if (map[key] !== idx) map[key] = idx
            { const _lk = this.tabAnchorKey(this.tabAttrs?.[idx]); if (_lk) this._liveTabKey = _lk }   // IE 2026 10 12 / ODOO-345618 (заказ Игоря: активная вкладка после перечитки): ключ живой вкладки — для liveTab_index
        },
        // IE 2026 10 12 / ODOO-345618 (заказ Игоря: активная вкладка после перечитки): индекс живой вкладки панели в ТЕКУЩЕМ наборе вкладок (по ключу tabAnchorKey), если она есть и видима; иначе -1 (прежнее поведение — вкладка вида по умолчанию).
        // Не раньше конца инициализации (первое открытие виджета не затронуто), не для вкладок из props. Выключатель fe.ux.keepActiveTab (по умолчанию вкл.)
        liveTab_index() {
            if (!this._initDone || !this._liveTabKey || this.localTabs_on() || this.store.setting('fe.ux.keepActiveTab', true) === false) return -1
            return (this.tabAttrs || []).findIndex(t => t && this.tabAnchorKey(t) === this._liveTabKey && this.isTabVisible(t))
        },
        // setCache() {
        //     // 2) перед размонтированием сохраняем текущее состояние
        //     this.store.vueObjCache[this.cacheKey] = {
        //         selectedIndex: this.tabPanel.selectedIndex,
        //     }
        // },
        initialized(tabPanel) {
            if (this.localTabs_on()) { this.localTabs_init(tabPanel); return }   // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): вкладки из props
            this.tabPanel = tabPanel;
            // IE 2026 09 06 / ODOO-336330: пользовательский выбор вкладки — после него selection_restore не вмешивается
            try { tabPanel.hostElement.addEventListener('mousedown', (e) => { if (e.target?.closest?.('.wj-tabheader')) this._userSelected = true }, true) } catch (e) { /* нет host */ }
            this.content_Changed()
            this._initDone = true   // IE 2026 09 10 / ODOO-…
            this.tabKeep_record(tabPanel)   // IE 2026 09 10 / ODOO-…: вкладка после инициализации (selectTab / attr.selectedIndex)
            if (tabPanel.selectedIndex >= 0) this.openedTabs[tabPanel.selectedIndex] = true
            this.settingsForm_ensureTab(tabPanel.selectedIndex, 'tab-init')   // IE 2026 09 28 / ODOO-5800: открылась сразу на вкладке-заглушке — догрузить форму
            this.$nextTick(() => this.displayDock_sync(tabPanel))   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р5): открылась сразу на вкладке Display — полоса справа

            // R13: остальные вкладки домонтируются в фоне после отрисовки видимой —
            // экшены бэка, адресующие контент ещё не открытой вкладки (set-binding,
            // set_visibleChart, ...), находят его как раньше; выигрыш — только в
            // моменте открытия панели. ОДНИМ пакетом: помонтажное «по одной в 0.7с»
            // на карточке с 20+ вкладками давало десяток перерисовок полосы вкладок
            // (репорт Igor, dev02 ЗаказПокупателя)
            if (this.store.fastEntry?.lazyTabs !== false) {
                // IE 2026 08 30 / ODOO-5800 (разбор рендера ie-triage7/core: 12 с блокировки
                // main thread, 63% из них ПОСЛЕ конца сети): домонтирование «одним пакетом»
                // строило разом все вкладки — на столе Purchase это 169 скрытых wijmo-гридов
                // из 171 (видимы 2) и длинные задачи до 1,6 с в тишине после загрузки.
                // Теперь тот же пакет нарезан на порции и выполняется в ПРОСТОЕ потока
                // (requestIdleCallback, fallback setTimeout): вкладки в итоге домонтируются
                // все (экшены бэка по-прежнему находят контент неоткрытой вкладки), но
                // поток отдаётся между порциями. Порция = 3 вкладки одним изменением
                // состояния — иначе полоса вкладок перерисовывается на каждую вкладку
                // (репорт Igor, dev02 ЗаказПокупателя — почему пакет и делался целиком).
                // Откат: window.perf.set('lazyTabsChunked', false) — прежний один пакет.
                const chunked = !this.store.perf_flag || this.store.perf_flag('lazyTabsChunked')
                const mountAllAtOnce = () => {
                    for (let i = 0; i < this.tabAttrs.length; i++) {
                        if (!this.openedTabs[i] && !this.tabsLazy_skip(i)) this.openedTabs[i] = true   // IE 2026 09 26 / ODOO-5800: выключенные — при активации
                    }
                }
                if (!chunked) {
                    this._lazyMountTimer = setTimeout(() => { this._lazyMountTimer = null; mountAllAtOnce() }, this.store.setting('fe.ux.lazyTabsDelayMs', 1200))   // IE 2026 09 05 / ODOO-336330
                } else {
                    const CHUNK = this.store.setting('fe.ux.lazyTabsChunk', 3)   // IE 2026 09 05 / ODOO-336330
                    const step = () => {
                        this._lazyMountIdle = null
                        if (this._unmounted) return
                        const pending = []
                        for (let i = 0; i < this.tabAttrs.length && pending.length < CHUNK; i++) {
                            if (!this.openedTabs[i] && !this.tabsLazy_skip(i)) pending.push(i)   // IE 2026 09 26 / ODOO-5800: выключенные — при активации
                        }
                        if (!pending.length) return
                        for (const i of pending) this.openedTabs[i] = true   // одно обновление на порцию
                        schedule()
                    }
                    const schedule = () => {
                        if (typeof window !== 'undefined' && window.requestIdleCallback) {
                            this._lazyMountIdle = window.requestIdleCallback(step, { timeout: 3000 })
                        } else {
                            this._lazyMountTimer = setTimeout(step, this.store.setting('fe.ux.lazyTabsStepMs', 200))   // IE 2026 09 05 / ODOO-336330
                        }
                    }
                    this._lazyMountTimer = setTimeout(schedule, this.store.setting('fe.ux.lazyTabsDelayMs', 1200))   // IE 2026 09 05 / ODOO-336330
                }
            }

            const pnl = tabPanel._dTabHeaders;
        },
        // R13: рендерить содержимое вкладки только после её первой активации
        // IE 2026 10 16 / ODOO-5800 (ЗП-20261016-2, dev02 16.10 22:19 п.2.2 — грид Transitions пуст до второго клика; разбор utils/lazyTabReveal.js): данные ленивой
        // вкладки пришли (store.updateDoc → lazyTab_afterData) — у выбранной ленивой вкладки проверяется её грид: зарегистрированный экземпляр вне документа
        // (поддерево вкладки пересоздано в отцепленный DOM) → вкладка перемонтируется; в документе и на экране, но сам себя ещё не показал → handleVisibility
        lazyTab_afterData(binding) {
            const W = this.WIDGET
            if (W && W._lazyTabInFlight) delete W._lazyTabInFlight[binding]
            if (!lazyTabReveal_on((k, d) => this.store?.setting?.(k, d))) return
            const idx = (this.tabAttrs || []).findIndex(t => t && t.lazyBinding === binding)
            if (idx < 0 || !this.tabPanel || this._unmounted || this.localTabs_on() || this.tabPanel.selectedIndex !== idx) return
            this.$nextTick(() => {
                if (this._unmounted || !this.tabPanel || this.tabPanel.selectedIndex !== idx) return
                // все живые экземпляры грида (реестр хранит последний — при пересозданном в отцепленный DOM поддереве он невидим, а на экране прежний, живой)
                const grids = []
                for (const a of lazyTab_gridAttrs(this.tabAttrs[idx], binding)) {
                    for (const g of [W?.attrs_vueObj?.[a.id], ...(W?._attrsLive?.[a.id] ? [...W._attrsLive[a.id]] : [])]) if (g && !grids.includes(g)) grids.push(g)
                }
                const rowsN = Array.isArray(this.store.get_value(W?.record, binding)) ? this.store.get_value(W.record, binding).length : 0
                // $el грида — не элемент (корень-фрагмент: comment-узел без offsetParent; dev02 16.10, проба 15) — положение берётся по хосту wijmo
                const hostOf = (g) => g.flex?.hostElement || (g.$el && g.$el.nodeType === 1 ? g.$el : null)
                const state = grids.map(g => { const h = hostOf(g); return { g, attached: !!h && (typeof document !== 'undefined') && document.contains(h), visible: !!h?.offsetParent, isVisible: g.isVisible,
                    empty: !(g.flex?.rows?.length > 0), has: rowsN > 0 } })
                const action = lazyTab_recovery(state)
                tabsLazy_count(action === 'remount' ? 'lazyTabRemounted' : (action === 'reveal' ? 'lazyTabRevealed' : 'lazyTabAlive'))
                if (action === 'remount') {
                    this.openedTabs[idx] = false
                    this.$nextTick(() => { if (!this._unmounted) { this.openedTabs[idx] = true; try { this.tabPanel?.refresh() } catch (e) { /* панель в перестройке */ } } })
                } else if (action === 'reveal') {
                    for (const st of lazyTab_revealTargets(state)) {
                        const g = st.g
                        try { if (typeof g.content_Changed === 'function') g.content_Changed() } catch (e) { console.warn('lazyTab reveal content_Changed', e) }
                        try { if (g.isVisible === false && typeof g.handleVisibility === 'function') g.handleVisibility(true) } catch (e) { console.warn('lazyTab reveal handleVisibility', e) }
                    }
                }
            })
        },
        tabRendered(indTab) {
            if (this.store.fastEntry?.lazyTabs === false) return true
            return !!this.openedTabs[indTab]
        },
        // Ключ активной вкладки для документации: имя вкладки, а если его нет —
        // слаг подписи (часть вкладок объявлена без name). Этот же ключ ищется
        // якорем в MD — см. docs, «guided documentation»
        tabAnchorKey(attrTab) {
            if (attrTab?.name) return attrTab.name
            // IE 2026 09 24 / ODOO-341407: слаг — из английской базы подписи, не из перевода (под uk/ru была «джерела» / «источники»
            // вместо «sources», и раздел не находился): перевод бэка (localize_attr) и живой смены языка (relocalize) кладёт исходник в {key}_en
            const base = (key) => (attrTab && typeof attrTab[`${key}_en`] === 'string') ? attrTab[`${key}_en`] : attrTab?.[key]
            const t = base('tooltip') || base('title') || ''
            return String(t).trim().toLowerCase().replace(/[^a-z0-9\u0400-\u04ff]+/g, '-').replace(/^-+|-+$/g, '')
        },
        // IE 2026 09 28 / ODOO-5800: цель перечитывания select из панели — компонент виджета (WidgetAttrs: get_selectedRow — выделенная строка,
        // get_vueObj), а не сама панель: у панели get_selectedRow нет, executeStoreMethod ронял промис TypeError-ом. Нет компонента — виджет закрыт
        // (widget_close жёстко: WIDGET.close, WIDGET.vueObj = null) или панель снимается: перечитывать нечего, метки ожидания ответа не ставятся
        rereadTarget(W) {
            if (this._unmounted || !W || W.close) return null
            const vo = W.vueObj
            return vo && typeof vo.get_selectedRow === 'function' ? vo : null
        },
        selectedIndexChanged(tabPanel) {
            // IE 2026 09 28 / ODOO-5800 (Игорь, dev02, 2W1_001 / 1EiJ_001: «vueObj.get_selectedRow is not a function»): панель снимается (beforeUnmount
            // уже был) — wijmo шлёт это событие, пока вкладки по одной уходят из панели (WjTab.unmounted): индекс съезжает, tabAttrs ему не соответствует,
            // выбора пользователя нет. Раньше такое событие у виджета на строках Ганта считалось «уходом с Ганта» и перечитывало закрытый виджет
            // (Variants → Use current / workspace_reopen, закрытие дочерних, тираж: WIDGET.vueObj = null → select с самой панелью → TypeError; dev-сборка
            // Vue после ошибки в unmounted-хуке не домонтировала переоткрытую страницу); заодно tabKeep_record затирал память вкладок съехавшим
            // индексом (замер dev02: главная панель Ганта 4 → 0), а openedTabs монтировал содержимое вкладок, по которым «проезжал» выбор
            if (this._unmounted) return
            if (this.localTabs_on()) { this.localTabs_changed(tabPanel); return }   // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): вкладки из props — только сообщить владельцу
            // IE 2026 09 06 / ODOO-336330: wijmo сам уводит выбор с невидимой вкладки на первую видимую; если задуманная
            // (индекс 0 / attr.selectedIndex / selectTab) в этот момент спрятана предварительной проверкой
            // и пользователь ещё не кликал — помечаем автосдвиг, selection_restore вернёт её, когда она появится
            {
                const want = this._intendedIndex ?? 0
                const t = this.tabAttrs?.[want]
                if (!this._userSelected && tabPanel.selectedIndex !== want && t && !this.isTabVisible(t)) this._autoMoved = true
            }
            // R13: вкладка активирована — смонтировать её содержимое
            if (tabPanel.selectedIndex >= 0 && !this.openedTabs[tabPanel.selectedIndex]) {
                this.openedTabs[tabPanel.selectedIndex] = true
                if (this._tabsLazySkipped?.has(tabPanel.selectedIndex)) tabsLazy_count('tabsMountedOnShow')   // IE 2026 09 26 / ODOO-5800: выключенная вкладка — смонтирована при активации
            }
            this.settingsForm_ensureTab(tabPanel.selectedIndex, 'tab')   // IE 2026 09 28 / ODOO-5800: открыта вкладка-заглушка (каркас формы настроек) — догрузить форму
            this.displayDock_sync(tabPanel)   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р5): вкладка Display — окно формы полосой справа; ушли с неё — прежний рект
            // кнопка «?» в шапке читает это значение в момент нажатия
            {
                const attrTab = this.tabAttrs?.[tabPanel.selectedIndex]
                if (this.WIDGET) this.WIDGET.activeTabAnchor = this.tabAnchorKey(attrTab)
                this.tabKeep_record(tabPanel)   // IE 2026 09 10 / ODOO-…
                try { this.WIDGET?.attrs_vueObj?.WIDGET?.compareMerge_tabShown?.(attrTab) } catch (e) { /* связь «Changes» ↔ форма не обязательна */ }   // IE 2026 10 31 / ODOO-349799 (PR3): показана вкладка «Changes» — выделить строку выбранной ячейки
            }
            // IE 2026 09 26 / ODOO-5800: строки ответа отобраны бэком под Гант движений (record._doc.gantt_rows_only, store.ganttMoves_requestParams) —
            // вкладка главной панели, отличная от Ганта (таблица, чарт, карта, настройки…), получает полные строки: данные перечитываются
            // (select уйдёт уже без отбора — открыта другая вкладка)
            {
                const attrTab = this.tabAttrs?.[tabPanel.selectedIndex], W = this.WIDGET
                const target = this.rereadTarget(W)   // IE 2026 09 28 / ODOO-5800: компонент виджета; нет его — select не зовётся, метки не ставятся
                if (this._initDone && target && attrTab && attrTab.name !== 'tabGanttMoves' && (W?.record?._doc?.gantt_rows_only || this.store.ganttMoves_rereadPending(W))   // IE 2026 09 27 / ODOO-5800: + перечитывание Гантом ещё в пути — его ответ лёг бы в таблицу
                    && (W.view || []).some(a => a?.id != null && a.id === this.attr?.id)) {
                    if (W.record._doc) delete W.record._doc.gantt_rows_only   // IE 2026 09 27 / ODOO-5800: _doc может не быть (ветка «в пути»)
                    W._ganttRereadSig = null   // IE 2026 09 27 / ODOO-5800: бэк отвечает Ганту признаками — следующий показ Ганта после усечённой выборки снова перечитает (ganttMoves_rereadOnShow)
                    W._ganttListRead = W.record   // IE 2026 09 27 / ODOO-5800: перечитывание «List» в пути, пока запись не заменена ответом (ganttMoves_rereadOnShow)
                    this.store.executeStoreMethod(target, { command: 'executeWidgetMethod', method: 'select', record_sendToBackend_exclude: ['_doc'] })   // IE 2026 09 28 / ODOO-5800: было W.vueObj || this
                }
            }
            // IE 2026 09 27 / ODOO-5800 (ie-dm-app7 #47092): обратный переход — показ вкладки Ганта главной панели, а строки пришли не запросом Ганта и выборка
            // неполная (List без чипса: 20 000 из 341 885) или перечитывание «List» ещё в пути — перечитать запросом Ганта (select уйдёт с gantt_moves — открыт
            // Гант): бэк вернёт плашку потолка или строки Ганта. Решение и выключатель fe.gantt.rereadAfterTruncatedList — store.ganttMoves_rereadOnShow. До ответа
            // Гант не строит модель из строк списка (метка W._ganttReread = запись, на которой послан запрос; ответ заменяет запись — ожидание кончается)
            {
                const attrTab = this.tabAttrs?.[tabPanel.selectedIndex], W = this.WIDGET
                const target = this.rereadTarget(W)   // IE 2026 09 28 / ODOO-5800: до ganttMoves_rereadOnShow — он ставит метку среза W._ganttRereadSig
                if (this._initDone && target && attrTab?.name === 'tabGanttMoves' && W?.record
                    && (W.view || []).some(a => a?.id != null && a.id === this.attr?.id) && this.store.ganttMoves_rereadOnShow(W)) {
                    W._ganttReread = W.record
                    this.store.executeStoreMethod(target, { command: 'executeWidgetMethod', method: 'select', record_sendToBackend_exclude: ['_doc'] })   // IE 2026 09 28 / ODOO-5800: было W.vueObj || this
                }
            }
            // вкладка печати: ленивая инициализация — форма заполняется бэком при
            // ПЕРВОМ входе; если уже заполнена, повторный вход не перезаполняет
            // (принудительно — кнопка Reload на панели печати)
            {
                const attrTab = this.tabAttrs?.[tabPanel.selectedIndex]
                if (attrTab?.name === 'tab-print') {
                    const WIDGET = this.WIDGET
                    const printRows = WIDGET?.record?._doc?.printPreview
                    if (!Array.isArray(printRows) || !printRows.length) {
                        this.store.executeStoreMethod(WIDGET?.vueObj || this, {
                            command: 'executeWidgetMethod', method: 'get_print', binding: '_doc.printPreview',
                        })
                    }
                }
            }
            // IE 2026 08 23 / ODOO-5884 (заказ Игоря): вкладка Versions списка — статистика по
            // версиям сегмента запрашивается при ПЕРВОМ открытии вкладки; повтор — кнопкой Refresh
            {
                const attrTab = this.tabAttrs?.[tabPanel.selectedIndex]
                // IE 2026 08 23 / ODOO-5884 (заказ Игоря): общий механизм — вкладка с lazyMethod/lazyBinding (Versions,
                // Branch › Statistics …) запрашивает данные при ПЕРВОМ открытии; повтор — кнопкой Refresh на её панели
                const lazyMethod = attrTab?.lazyMethod || (attrTab?.name === 'tab-versions' ? 'versions_stats' : '')
                const lazyBinding = attrTab?.lazyBinding || (attrTab?.name === 'tab-versions' ? '_doc.versions_stats' : '')
                if (lazyMethod && lazyBinding) {
                    const WIDGET = this.WIDGET
                    const rows = lazyBinding.split('.').reduce((o, k) => (o == null ? o : o[k]), WIDGET?.record)
                    // IE 2026 10 13 / ODOO-5800: список с несохранёнными правками (все строки удалены — пуст) повторной загрузкой не затирается (полоса Save, store.gridSave_dirty)
                    const lazyDirty = !!WIDGET?._gridSave?.[lazyBinding] && this.store.gridSave_dirty(WIDGET).some(x => x.binding === lazyBinding)
                    // IE 2026 10 29 / ODOO-5800 (заказ Игоря: история изменений списка, ie-dm7 #114916): K5 — вкладка истории списка: ответ уже есть (объект со state) — повторный вход не перезапрашивает и не откатывает выбор пользователя
                    // к умолчаниям (повтор — кнопкой Refresh в AttrListHistory); lite = 1 не шлём — основной ответ v2 и так лёгкий (ANSWERS-BE В6)
                    const lazyHasAnswer = attrTab?.name === 'tab-list-history' && !!rows && typeof rows === 'object' && !Array.isArray(rows) && !!rows.state
                    // IE 2026 10 16 / ODOO-5800 (dev02 16.10, вкладка Transitions: клик + initialized + lhMounted пересозданной панели слали запрос трижды) — один запрос в пути на привязку
                    const lazyFree = !lazyHasAnswer && (!lazyTabReveal_on((k, d) => this.store?.setting?.(k, d)) || lazyTab_canSend(WIDGET && (WIDGET._lazyTabInFlight || (WIDGET._lazyTabInFlight = {})), lazyBinding))   // IE 2026 10 29 / ODOO-5800: !lazyHasAnswer — без отметки «в пути»
                    if ((!Array.isArray(rows) || !rows.length) && !lazyDirty && lazyFree) {
                        // IE 2026 10 14 / ODOO-345813 (заказ Игоря: окна остановок регламента): значение открытого редактора ячейки (Scope формы окна) доводится до записи сейчас — wijmo сделал бы это
                        // таймером lostFocus (5 мс) уже ПОСЛЕ отправки, и Preview уходил со старым scope (fe.ux.commitEditsBeforeAction)
                        editCommit_pending(WIDGET, this.store, 'lazyTab:' + lazyMethod)
                        this.store.executeStoreMethod(WIDGET?.vueObj || this, {
                            command: 'executeWidgetMethod', method: lazyMethod, binding: lazyBinding,
                            record_sendToBackend_exclude: ['_doc'],
                            // IE 2026 10 29 / ODOO-5800 (ie-dm7 #114932: история fast → deep, стадии ответа): первый запрос вкладки History of changes — быстрый слой (глубокий компонент запросит следом); fe.ux.pmHistoryStaged
                            ...(attrTab?.name === 'tab-pm-history' && this.store.setting('fe.ux.pmHistoryStaged', true) !== false ? { params: { history: { stage: 'fast' } } } : {}),
                            ...(attrTab?.name === 'tab-pm-history' ? pmHistory_slimFields((k, d) => this.store.setting(k, d)) : {}),   // IE 2026 10 29 / ODOO-5800 (ie-dm7 r62 #115629: D1): без view отчёта (fe.data.pmHistorySlim)
                        })
                    }
                }
            }
            // вкладка истории запусков (_doc.data_log): данные запрашиваются при
            // ОТКРЫТИИ вкладки; при повторном входе бэк вернёт их только при
            // наличии новых записей (last_log_sequence_id → not modified = {})
            {
                const attrTab = this.tabAttrs?.[tabPanel.selectedIndex]
                if (attrTab?.name === 'tabLOG') {
                    const WIDGET = this.WIDGET
                    const rows = WIDGET?.record?._doc?.data_log
                    const last = Array.isArray(rows) && rows.length ? rows[0]?.sequence_id : null
                    this.store.executeStoreMethod(WIDGET?.vueObj || this, {
                        command: 'executeWidgetMethod', method: 'select_log', binding: '_doc.data_log',
                        ...(last != null ? { last_log_sequence_id: last } : {}),
                    })
                }
            }
            // if (this.WIDGET.isMove) {
            //     // это не пользователь, а наше внутреннее присваивание → игнорируем
            //     return
            // }

            // syncTabReveal: показать вкладку ОДНИМ кадром. Грид, отрендеренный
            // в скрытой панели, стоит сплюснутым и без строк; v-visible
            // (IntersectionObserver) добежит только ПОСЛЕ первого кадра — отсюда
            // мелькание «пустой → полный». Клик ещё не отрисован, поэтому
            // доделки (resize + handleVisibility) выполняем синхронно сейчас,
            // а для только что смонтированной вкладки — в nextTick (тоже до кадра)
            if (this.store.fastEntry?.syncTabReveal !== false) {
                const reveal = () => {
                    const host = tabPanel.hostElement
                    if (!host || !this.WIDGET) return
                    // wijmo применяет смену панели ОТЛОЖЕННО (invalidate →
                    // следующий кадр): на момент события в DOM видима ещё старая
                    // панель — доводим DOM до актуального состояния сейчас
                    tabPanel.refresh()
                    const pane = tabPanel.tabs?.at?.(tabPanel.selectedIndex)?.pane
                        || host.querySelectorAll(':scope > div > .wj-tabpanes > .wj-tabpane')[tabPanel.selectedIndex]
                    if (!pane || getComputedStyle(pane).display === 'none' || pane.offsetParent === null) return
                    this.store.widgetResize_afterTimer(this) // размеры контейнеров — до кадра
                    // компоненты — обходом Vue-поддерева панели (parent-first):
                    // реестр attrs_vueObj держит по ключу только внешний компонент
                    // (AttrTabGrid), вложенные в него гриды туда не попадают
                    const comps = []
                    const walkVnode = (vnode) => {
                        if (!vnode) return
                        if (vnode.component) {
                            const p = vnode.component.proxy
                            if (p && typeof p.handleVisibility === 'function') comps.push(p)
                            walkVnode(vnode.component.subTree)
                        } else if (Array.isArray(vnode.children)) {
                            for (const c of vnode.children) walkVnode(c)
                        }
                    }
                    walkVnode(this.$?.subTree)
                    const revealed = []
                    for (const p of comps) {
                        const el = p.$refs?.attr_container || p.$el
                        if (!p.isVisible && el instanceof Element && pane.contains(el)) {
                            const t0 = performance.now()
                            p.handleVisibility(true)
                            revealed.push(`${p.attr?.name || p.attr?.binding || '?'}+${Math.round(performance.now() - t0)}ms`)
                        }
                    }
                    if (this.store.fastEntry.timings) {
                        console.log(`[fastEntry:tabs] reveal idx=${tabPanel.selectedIndex}`
                            + ` comps=${comps.length} disp=${getComputedStyle(pane).display}`
                            + ` revealed=[${revealed.join(', ')}]`)
                    }
                }
                reveal()
                // повтор после флаша рендера: компоненты, домонтированные ходом
                // первого reveal (вложенные гриды), — тоже до отрисовки кадра
                this.$nextTick(reveal)
                // и ещё раз прямо перед отрисовкой: вложенные реестры
                // (AttrTabGrid → sub-гриды) монтируются на хоп позже nextTick,
                // а их content_Changed уходит в 1мс-таймер уже ПОСЛЕ кадра —
                // rAF выполняется до paint, после всех рендер-флашей
                requestAnimationFrame(() => { if (this.tabPanel) reveal() })
            }

            // console.log('selectedIndexChanged')
            // this.store.rightArea_setDataSource(this, this.attr.binding, this.attr.configType)
            this.store.widgetResize(this, 0)
            // this.setCache()

            // // refresh AttrJSON FIXED in handleVisibility(...)
            // let attrs = this.attr.attrs[tabPanel.selectedIndex].attrs,
            //     vueObj = this.WIDGET.vueObj
            // vueObj.content_Changed(attrs, null, ['AttrJSON','AttrStrMulti'])

        },
        refreshed(tabPanel) {
            if (this.localTabs_on()) return   // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): вкладки из props — виджет не ресайзится
            this.store.widgetResize(this, 0)
        },
        // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): ВКЛАДКИ ИЗ PROPS (localTabs) — см. props
        localTabs_on() { return Array.isArray(this.localTabs) },
        localTabs_index(name) { return (this.localTabs || []).findIndex(t => t && t.name === name) },
        // панель построена: выбрать вкладку владельца (localSelected) — сейчас и после первого кадра (вкладки wijmo добавляются дочерними wj-tab);
        // события wijmo до этого (добавление вкладок, стартовый выбор) владельцу не сообщаются
        localTabs_init(tabPanel) {
            this.tabPanel = tabPanel
            this.localTabs_select(this.localSelected)
            this.$nextTick(() => { if (this._unmounted) return; this.localTabs_select(this.localSelected); this._initDone = true })
        },
        localTabs_select(name) {
            const tp = this.tabPanel
            const idx = this.localTabs_index(name)
            if (!tp || idx < 0 || !tp.tabs || idx >= tp.tabs.length || tp.selectedIndex === idx) return
            tp.selectedIndex = idx
            try { tp.refresh() } catch (e) { /* панель в перестройке */ }
        },
        // выбор пользователя → владельцу (name); смена панели у wijmo отложенная (invalidate → следующий кадр) — показать новую сразу, владелец меряет уже показанную
        localTabs_changed(tabPanel) {
            if (!this._initDone) return
            const t = (this.localTabs || [])[tabPanel.selectedIndex]
            if (!t || t.name === this.localSelected) return
            try { tabPanel.refresh() } catch (e) { /* панель в перестройке */ }
            this.$emit('local-select', t.name)
        },
        gotFocus(s) {
            // console.log('gotFocus')
        },
        lostFocus(s) {
            // console.log('lostFocus')
        },
        // IE 2026 09 26 / ODOO-5800 (fe.ux.tabsLazyHidden, utils/tabsLazy.js): вкладка ВЫКЛЮЧЕНА — use: false (у useNew — viewParams.<имя>.use === false), то же
        // правило use, что в isTabVisible; спрятанные пустыми (hide) и недоступные вкладки выключенными не считаются — их монтирование прежнее
        tabDisabled(attrTab) {
            if (!attrTab || attrTab.use !== false) return false
            if (attrTab.useNew === true && attrTab.name === HEATMAP_GRID_TAB) return !heatmapGridTab_use(this.store.get_value(this.WIDGET?.record, 'doc.viewParams'), (k, d) => this.store.setting(k, d))   // IE 2026 11 03 / ODOO-350449 (heatmap tab swap)   // IE 2026 11 03 / ODOO-350449 (webscm review): + выключатель fe.ux.heatmapGridUseFromOld
            if (attrTab.useNew === true && attrTab.name) return this.store.get_value(this.WIDGET?.record, `doc.viewParams.${attrTab.name}.use`) === false
            return true
        },
        // IE 2026 09 26 / ODOO-5800: фоновое домонтирование (R13) пропускает выключенную вкладку — она монтируется при активации (selectedIndexChanged);
        // счётчик tabsLazy.stats().tabsSkipped — по разу на вкладку панели
        tabsLazy_skip(i) {
            const t = this.tabAttrs?.[i]
            if (!t || !this.tabDisabled(t) || !tabsLazy_on(this.store)) return false
            const seen = this._tabsLazySkipped || (this._tabsLazySkipped = new Set())
            if (!seen.has(i)) { seen.add(i); tabsLazy_count('tabsSkipped') }
            return true
        },
        // IE 2026 11 03 / ODOO-350449 (heatmap tab s134): вкладки теплокарты при скрытой старой (fe.ux.heatmapOldTabHidden) — иконка и подпись из словаря фронта, не из записи (работает без пересева)
        tabDecor(attrTab) { return this.localTabs_on() ? null : heatmapTab_decor(attrTab, this.heatmapOldHidden(), this.t) },   // IE 2026 11 03 / ODOO-350449 (heatmap tab s134)   // IE 2026 11 03 / ODOO-350449 (webscm review): старая скрыта — только при видимой таблице (heatmapOldHidden)
        heatmapOldHidden() {   // IE 2026 11 03 / ODOO-350449 (webscm review): старая вкладка пузырей скрыта (fe.ux.heatmapOldTabHidden), только если таблица включена (fe.ux.heatmapGridTab) и видна на её месте — иначе видна старая
            return heatmapOldTab_hide((k, d) => this.store.setting(k, d), () => { const g = (this.tabAttrs || []).find(x => x && x.name === HEATMAP_GRID_TAB); return !!g && this.isTabVisible(g) })   // IE 2026 11 03 / ODOO-350449 (webscm review)
        },   // IE 2026 11 03 / ODOO-350449 (webscm review)
        tabPi(attrTab) { const d = this.tabDecor(attrTab); return d ? d.pi : attrTab?.pi },   // IE 2026 11 03 / ODOO-350449 (heatmap tab s134)
        tabTip(attrTab) { const d = this.tabDecor(attrTab); return d ? d.tooltip : attrTab?.tooltip },   // IE 2026 11 03 / ODOO-350449 (heatmap tab s134)
        tabTitle(attrTab) { const d = this.tabDecor(attrTab); return d ? d.title : attrTab?.title },   // IE 2026 11 03 / ODOO-350449 (heatmap tab s134)
        tabIdx_fix(idx) { return this.localTabs_on() ? idx : heatmapTab_redirectIndex(this.tabAttrs, idx, (t) => this.isTabVisible(t)) },   // IE 2026 11 03 / ODOO-350449 (heatmap tab s134)
        isTabVisible(attrTab) {
            // IE 2026 09 18 / ODOO-… (заказ Игоря: вкладка Styles): useNew — вкладка с компонентом, которого нет у прежних фронтов:
            // шаблон несёт use: false (прежний фронт её прячет — формы базы общие с боевым контуром), фронт с компонентом
            // показывает её, пока вкладку не выключили настройкой вида (viewParams.<имя>.use === false)
            if (attrTab.name === HEATMAP_OLD_TAB && this.heatmapOldHidden()) return false   // IE 2026 11 03 / ODOO-350449 (heatmap tab swap): вкладка пузырей скрыта — её место заняла таблица (выключатель fe.ux.heatmapOldTabHidden)   // IE 2026 11 03 / ODOO-350449 (webscm review): было heatmapOldTab_hidden(...) — при выключенной / невидимой таблице старая вкладка видна
            let use = attrTab.use !== false
            if (!use && attrTab.useNew === true && attrTab.name) {
                use = attrTab.name === HEATMAP_GRID_TAB ? heatmapGridTab_use(this.store.get_value(this.WIDGET?.record, 'doc.viewParams'), (k, d) => this.store.setting(k, d)) : this.store.get_value(this.WIDGET?.record, `doc.viewParams.${attrTab.name}.use`) !== false   // IE 2026 11 03 / ODOO-350449 (heatmap tab swap): таблица — своя настройка, иначе настройка старой вкладки (Views → Heatmap → Use)   // IE 2026 11 03 / ODOO-350449 (webscm review): + выключатель fe.ux.heatmapGridUseFromOld
                // IE 2026 09 28 / ODOO-342342 (Use cases): вкладка с формой-меню кейсов (AttrUseCaseMenu) при выключенном fe.guide.cases — как у прежнего фронта (спрятана)
                if (use && guideCases_tabHidden(this.store, attrTab)) use = false
                if (use && attrTab.name === HEATMAP_GRID_TAB && !heatmapGridTab_on((k, d) => this.store.setting(k, d))) use = false   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: теплова карта на базі таблиці — порівняльна вкладка): выключатель fe.ux.heatmapGridTab — вкладки нет
            }
            return use && attrTab.hide !== true && this.store.checkAccess(attrTab)
        },
        // IE 2026 09 06 / ODOO-336330 (заказ Игоря: «два кадра вкладок» при открытии виджета): прежде вкладки рисовались ВСЕ, а пустые
        // прятал их единственный дочерний грид/MD/текст уже после своего монтирования (активная — после ответа,
        // остальные — порциями lazyTabs через 1,2 с) → полоса вкладок худела в несколько кадров. Теперь ДО первого
        // рендера панели (и повторно при set_nonEmptyWidget: ответ widget_open, updateWIDGET, Alt+A) вкладка
        // оценивается по ДАННЫМ записи тем же правилом, что в check_attrTab: одиночный дочерний AttrGrid/AttrMD/
        // AttrStrMulti без showEmpty при включённой «Hide empty rows, columns, tabs» — пустые (и ещё не загруженные,
        // как и у грида: attr_get → []) не показываются; те, чьи данные подтвердились, появляются. Вердикт
        // реальной проверки (parent_attr._hideChecked) предварительная не перебивает. Ленивые вкладки
        // (lazyMethod/lazyBinding, Versions/Print/Log) не трогаем — их данные приходят при активации.
        // Счётчики: this._tabsPrecheck. Выкл: window.fastEntry.set('tabsPrecheck', false)
        // IE 2026 09 06 / ODOO-336330: вернуть задуманную вкладку после того, как она появилась (p2), если wijmo увёл выбор
        // с неё, пока она была спрятана, и пользователь по полосе не кликал; выбор на невидимой/отсутствующей
        // вкладке (-1) чиним всегда — иначе панель без содержимого
        selection_restore() {
            const tp = this.tabPanel
            if (!tp || this._unmounted || this.localTabs_on()) return   // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): вкладки из props ведёт владелец
            const tabs = this.tabAttrs || []
            const visible = (i) => i >= 0 && i < tabs.length && this.isTabVisible(tabs[i])
            const cur = tp.selectedIndex
            const curBad = !visible(cur)
            if (!curBad && (!this._autoMoved || this._userSelected)) return
            let want = this.tabIdx_fix(this._intendedIndex ?? 0)   // IE 2026 11 03 / ODOO-350449 (heatmap tab s134): задуманная — скрытая старая Heatmap: таблица
            if (!visible(want)) { if (!curBad) return; want = tabs.findIndex((t) => this.isTabVisible(t)) }
            if (want < 0 || want === cur) return
            try { tp.refresh() } catch (e) { /* панель в перестройке */ }
            this._autoMoved = false
            tp.selectedIndex = want
            const st = this._tabsPrecheck || (this._tabsPrecheck = { runs: 0, hidden: 0, shown: 0 })
            st.restored = (st.restored || 0) + 1
        },
        // IE 2026 09 07 / ODOO-337259: подсказка вкладки «ленивая» (v-wjTooltipFn) — контент при показе (Alt / Show tooltips)
        // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U3: СОСТАВЛЯТЬ — текст вкладки бэка остаётся шапкой, наши строки дописываются после
        tabTooltipFn(attrTab) {
            return () => {
                // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): вкладка из props со своим ключом объяснения (help: { key, state }) — объяснение этого ключа
                if (this.localTabs_on() && attrTab.help && attrTab.help.key) {
                    if (!uiHelp_enabled()) return attrTab.tooltip || ''
                    let st = null
                    try { st = typeof attrTab.help.state === 'function' ? attrTab.help.state() : (attrTab.help.state ?? null) } catch (e) { st = null }
                    return uiHelp_html(attrTab.help.key, { state: st }) || attrTab.tooltip || ''
                }
                const base = this.tabTip(attrTab) || ''   // IE 2026 11 03 / ODOO-350449 (heatmap tab s134)
                if (!uiHelp_enabled()) return base
                const rows = uiHelp_rowsHtml('widget.tabs.tab', { vars: { name: this.tabTitle(attrTab) || '' } }, ['what', 'click'])   // IE 2026 11 03 / ODOO-350449 (heatmap tab s134)
                return base ? base + rows : rows.replace(/^<br>/, '')
            }
        },
        // IE 2026 09 28 / ODOO-5800 (форма настроек по требованию, utils/settingsFormLazy.js): выбранная вкладка — заглушка каркаса формы
        settingsForm_ensureTab(idx, reason) {
            const t = idx >= 0 ? this.tabAttrs?.[idx] : null
            if (t?.lazyForm && this.WIDGET) this.store.settingsForm_ensure(this.WIDGET, reason)
        },
        tabsPrecheck() {
            if (this.store?.fastEntry?.tabsPrecheck === false) return
            const WIDGET = this.WIDGET, tabs = this.attr?.attrs
            if (!WIDGET || !Array.isArray(tabs)) return
            const btn = this.store.get_field0(WIDGET.groupMenu?.commandPanel, 'non-empty-widget', 'name')
            const active = !!btn?.active
            const st = this._tabsPrecheck || (this._tabsPrecheck = { runs: 0, hidden: 0, shown: 0 })
            st.runs++
            const LAZY = new Set(['tab-versions', 'tab-print', 'tabLOG'])
            for (const tab of tabs) {
                if (!tab || tab.use === false || tab._hideChecked) continue
                if (!active) { if (tab._hidePre) { tab.hide = false; tab._hidePre = false; st.shown++ } continue }
                if (tab.showEmpty || tab.lazyMethod || tab.lazyBinding || LAZY.has(tab.name)) continue
                if (tab.attr_type !== 'AttrTab' && tab.attr_type !== 'AttrTabRow') continue
                // IE 2026 09 28 / ODOO-5800: заглушка каркаса формы — единственный ребёнок вкладки описан бэком (lazyPrecheck: тип, привязка, showEmpty)
                if (tab.lazyForm ? !tab.lazyPrecheck : (!Array.isArray(tab.attrs) || tab.attrs.length !== 1)) continue
                const c = tab.lazyForm ? tab.lazyPrecheck : tab.attrs[0]
                if (!c || c.showEmpty || !c.binding) continue
                let empty
                if (c.attr_type === 'AttrGrid') {
                    const v = this.store.attr_get(WIDGET, c)
                    empty = !Array.isArray(v) || v.length === 0
                } else if (c.attr_type === 'AttrMD' || c.attr_type === 'AttrStrMulti') {
                    empty = !String(this.store.attr_get(WIDGET, c) || '').trim()
                } else continue
                if (empty && c.attr_type === 'AttrGrid' && WIDGET.audit_diff && adf_tableChanged(WIDGET.audit_diff, c.binding, (k, d) => this.store.setting(k, d))) empty = false   // IE 2026 10 31 / ODOO-349799: ТЧ пуста в этой версии, но изменена — вкладка нужна переходу ‹ ›
                if (empty) {
                    if (tab.hide !== true) { tab.hide = true; st.hidden++ }
                    tab._hidePre = true
                } else if (tab._hidePre) {
                    tab.hide = false; tab._hidePre = false; st.shown++
                }
            }
        },
        tabInitialAttr(attrTab) {
            // вкладку объектом — только табовым компонентам: прочим (например грид
            // прямым ребёнком панели) initialAttr переключил бы их собственную логику
            return (attrTab.component === 'AttrTab' || attrTab.component === 'AttrTabRow') ? attrTab : null
        },
        // IE 2026 10 12 / ODOO-345618 (заказ Игоря: бейдж согласования на вкладке вместо чипса): бейдж вкладки tab-approval — из чипса сводки record.doc._info_chips (перечитка отчёта приносит новый чипс — бейдж следует за ним).
        // Вкладки из props (окно легенды) бейджа не несут; выключатель fe.ux.approvalTabBadge (выкл. — бейджа нет, чипс в ряду чипсов)
        approvalBadge(attrTab) {
            if (attrTab?.name !== 'tab-approval' || this.localTabs_on() || !approvalTabBadgeOn((k, d) => this.store.setting(k, d))) return null
            return approvalTabBadge(this.WIDGET?.record?.doc?._info_chips, (n) => this.store.formatCount(n), approvalTabBadgeScopedOn((k, d) => this.store.setting(k, d)))   // IE 2026 10 13 / ODOO-5800: по строкам отчёта (fe.approval.scopedBadge)
        },
        // IE 2026 10 13 / ODOO-5800 (заказ Игоря: бейдж — только по позициям отчёта): состояние подсказки бейджа — normal / status, по строкам отчёта — rowsNormal / rowsStatus
        approvalBadgeState(attrTab) {
            const b = this.approvalBadge(attrTab)
            const red = b?.css === 'status'
            if (b?.scope) return red ? 'rowsStatus' : 'rowsNormal'
            return red ? 'status' : 'normal'
        },
        // IE 2026 10 11 / ODOO-345618 (заказ Игоря: согласование под ключ) — FE3: вкладка «Approval» отчёта — фронтовая (бэк её не шлёт): главная панель вида (view[0] с вкладкой tabSheet) виджета REPORT2, у записи есть doc._approval
        // (сегмент с политикой) и бэк не выключил сводку (doc._approval.overview !== false). Содержимое — ApprovalOverview (source report), данные — approval_overview при первом открытии.
        // Объект вкладки один на экземпляр панели (ключ v-for стабилен); showEmpty — предпроверка пустых вкладок её не прячет. Выключатель fe.ux.approvalTab (по умолчанию вкл.)
        approvalTab_get(tabs) {
            const W = this.WIDGET
            if (!W || !this.attr || !tabs.length || tabs.some(x => x?.name === 'tab-approval')) return null
            const v0 = Array.isArray(W.view) ? W.view[0] : null
            if (!v0 || (v0 !== this.attr && (v0.id == null || v0.id !== this.attr.id))) return null
            if (!tabs.some(x => x?.name === 'tabSheet') || !/REPORT2/.test(String(W.widget_class || W.record?.segment || ''))) return null
            const da = _apDoc(W.record?.doc)
            if (!da || da.overview === false || this.store.setting('fe.ux.approvalTab', true) === false) return null
            if (!this._apTab) this._apTab = { name: 'tab-approval', attr_type: 'AttrTab', component: 'ApprovalOverview', html_id: String(this.attr.id || this.attr.html_id || 'panel') + '_tab-approval', pi: 'pi pi-verified', showEmpty: true, use: true }
            // IE 2026 10 11 / ODOO-345618 (заказ Igor: иконки первого ряда — только с подсказками): вкладка — одна иконка без подписи, название — в подсказке по Alt (tooltip), как у вкладок бэка
            this._apTab.title = ''
            this._apTab.tooltip = _apT('Approval')
            return this._apTab
        },
        // IE 2026 11 03 / ODOO-350449 (заказ Игоря: все варианты отображения — во вкладке Display шестерёнки, не на форме): вкладка «Display» — фронтовая (бэк её не шлёт),
        // последней в главной панели формы вида ⚙ грида (widget-row-viewParams: view[0] — эта панель), когда для источника формы есть хоть одна опция реестра
        // (utils/displayOptions.js, scope). Содержимое — DisplayOptionsTab; объект вкладки один на экземпляр панели (ключ v-for стабилен). Выключатель fe.ux.displayTab (дефолт ВКЛ)
        // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р5): только главная панель формы вида ⚙ (у неё есть вкладка Display — this._dispTab); вложенные панели вкладок окно не двигают.
        // Активна Display — окно формы (popout) узкой полосой у правого края страницы на всю высоту; другая вкладка — прежний рект (utils/displayTabDock.js)
        displayDock_sync(tabPanel) {   // IE 2026 11 04 / ODOO-350449 (гейт webscm #129296 Р5)
            if (this._unmounted || !this._dispTab || !this.WIDGET) return
            const tp = tabPanel || this.tabPanel
            const onDisplay = !!tp && tp.selectedIndex >= 0 && this.tabAttrs?.[tp.selectedIndex]?.name === DISPLAY_TAB
            try {
                if (onDisplay && displayDock_on((k, d) => this.store.setting(k, d))) displayDock_apply(this.store, this.WIDGET, true)
                else if (displayDock_isDocked(this.WIDGET)) displayDock_apply(this.store, this.WIDGET, false)
            } catch (e) { console.warn('displayDock', e) }
        },
        displayTab_get(tabs) {   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: все варианты отображения — во вкладке Display шестерёнки, не на форме)
            const W = this.WIDGET
            if (!W || !this.attr || W.widget !== 'widget-row' || W.record?._meta?.type !== 'widget-row-viewParams' || tabs.some(x => x?.name === DISPLAY_TAB)) return null
            const v0 = Array.isArray(W.view) ? W.view[0] : null
            if (!v0 || (v0 !== this.attr && (v0.id == null || v0.id !== this.attr.id))) return null
            if (!displayTab_on((k, d) => this.store.setting(k, d))) return null
            if (!displayOptions_forCtx(displayCtx_ofRow(this.store, W)).length) return null
            if (!this._dispTab) this._dispTab = { name: DISPLAY_TAB, attr_type: 'AttrTab', component: 'DisplayOptionsTab', html_id: String(this.attr.id || this.attr.html_id || 'panel') + '_' + DISPLAY_TAB, pi: 'pi pi-palette', showEmpty: true, use: true, title: '' }
            this._dispTab.tooltip = _apT('Display')
            return this._dispTab
        },
        tabBindings(attrTab) {
            // IE 2026 08 17 / ODOO-4997 (замечание Игоря): parent_type — проп только
            // табовых компонентов (AttrTab/AttrTabRow/AttrTabPanel); прочим (грид,
            // граф, чарт …) он не объявлен, и Vue на каждый рендер сыпал в консоль
            // «Extraneous non-props attributes (parent_type)» — передаём адресно
            const out = {}
            const ia = this.tabInitialAttr(attrTab)
            if (ia) { out.initialAttr = ia; out.parentAttr = this.attr }
            if (['AttrTab', 'AttrTabRow', 'AttrTabPanel'].includes(attrTab.component)) out.parent_type = 'AttrTabPanel'
            return out
        },
    },
    watch: {
        // IE 2026 09 06 / ODOO-336330: набор видимых вкладок изменился (предварительная или реальная проверка) — вернуть задуманную
        tabsVisibleKey() { this.$nextTick(() => this.selection_restore()) },
        // IE 2026 09 25 / ODOO-341407 (№17): метка стартовой вкладки пришла, когда панель уже инициализирована (кадр со снимка) — применить
        'WIDGET.activeTab'(v) { if (v) this.$nextTick(() => this.activeTab_apply()) },
        // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): вкладки из props — владелец сменил выбранную вкладку
        localSelected(v) { if (this.localTabs_on()) this.localTabs_select(v) },
    },
    computed: {
        tabsVisibleKey() {
            return (this.tabAttrs || []).map((t) => (t.use !== false && t.hide !== true) ? '1' : '0').join('')
        },
        // вкладки-шапки (pinnedHeader) — над панелью; в полосу вкладок не попадают
        pinnedTabs() {
            return (this.attr?.attrs || []).filter(t => t.pinnedHeader && this.isTabVisible(t))
        },
        tabAttrs() {
            if (Array.isArray(this.localTabs)) return this.localTabs   // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): вкладки из props
            const _tabs = (this.attr?.attrs || []).filter(t => !t.pinnedHeader)
            const _ap = this.approvalTab_get(_tabs)   // IE 2026 10 11 / ODOO-345618 (заказ Игоря: согласование под ключ) — FE3: вкладка «Approval» (картина процесса согласования) — последней
            const _dt = this.displayTab_get(_tabs)   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: все варианты отображения — во вкладке Display шестерёнки, не на форме)
            return [..._tabs, ...(_ap ? [_ap] : []), ...(_dt ? [_dt] : [])]   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: все варианты отображения — во вкладке Display шестерёнки, не на форме)
        },
        cacheKey() {
            const q = this.$route.query || {}
            // завязываемся только на workspace + widget + attr
            // можно добавить page/process_model по желанию
            return [
                'AttrTabPanel',
                q.workspace || 'no-ws',
                this.widget_id,
                this.attr_id,
            ].join(':')
        },
    //     filteredAttrs() {
    //         if (this.attr?.attrs) {
    //             return this.attr.attrs.filter(attr => this.store.get_viewParam(this.WIDGET, attr.name, 'use', true, attr)) // attr.use !== false
    //         } else {
    //             return []
    //         }
    //     }
    },
    // watch: {
    //     'WIDGET?.record?.doc?.viewParams': {
    //         handler(newValue) {
    //             this.filteredAttrs
    //         },
    //         deep: true
    //     }
    // }
}
</script>

<style>
.attr-tab-panel {
    width:-webkit-fill-available;
    /* display: flex; */
    /* flex-wrap: wrap; */
}
/* шапка-реквизиты над панелью вкладок (pinnedHeader) */
.tab-panel-pinned {
    margin-bottom: 2px;
}
.wj-tabheaders {
    background: white;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 100;
}
.wj-tabpanes {
    padding-top: 2px;
}
/* верхнюю линию контента не дублируем (разделитель — у .widget-container);
   !important — правило wijmo.css (.wj-tabpanel>div>.wj-tabpanes) той же
   специфичности загружается позже и иначе побеждает по порядку */
.wj-tabpanes {
    border-top: none !important;
}
.wj-tabpanel > div > .wj-tabpanes {
    overflow: visible;
}
.wj-tabpanel>div>.wj-tabheaders>.wj-tabheader:after {
    background: linear-gradient(90deg, rgba(255, 150, 30, 0.6), rgba(255, 150, 30, 0.9));
    height: 3px;
    border-radius: 3px;
}
.wj-tabpanel>div>.wj-tabheaders>.wj-tabheader.wj-state-active {
    background: #fff;
    color: #647eff;
}

.tabs-align-right .wj-tabheaders {
    text-align: right;
}

/* tabs on the right */
.wj-tabpanel.tabs-position-right>div {
    display: flex;
    align-items: start;
}

.wj-tabpanel.tabs-position-right .wj-tabheaders {
    display: flex;
    flex-direction: column;
    min-width: 8em;
    border-left: 1px solid #ddd;
    order: 1;
}

.wj-tabpanel.tabs-position-right .wj-tabheaders .wj-tabheader {
    text-align: left;
}

.wj-tabpanel.tabs-position-right .wj-tabpanes {
    display: flex;
    flex-grow: 1;
    border-top: none;
    overflow-x: hidden;
    order: 0;
}

.badge {
    position: absolute;
    top: 0px;
    right: -7px;
    background-color: var(--cs-accent, rgba(100, 119, 239, 0.6));
    color: #ffffff;
    border-radius: 12px;
    padding: 1px 4px;
    font-size: 7px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
}
/* IE 2026 09 12 / ODOO-335246 (Igor): уровень бейджа каскада: on — белый, use — жёлтый, auto — зелёный; dirty (ниже) — поверх */
.badge.badge-lvl-on { background-color: #ffffff; color: var(--cs-accent, #6477ef); border: 1px solid var(--cs-accent, rgba(100, 119, 239, 0.6)); }
.badge.badge-lvl-use { background-color: #f2c21b; color: #3b2f00; }
.badge.badge-lvl-auto { background-color: #2e9e4f; color: #ffffff; }
/* IE 2026 09 21 / ODOO-5800 (замечание Игоря: красный бейдж вкладки Metrics — строки с grade = bad) */
.badge.badge-bad {
    background-color: #e5484d;
    color: #ffffff;
}
/* IE 2026 09 08 / ODOO-335246 (Igor): бейдж вкладки при грязных узлах каскада на источниках — жёлто-коричневый */
.badge.badge-dirty {
    background-color: #c98a12;
    color: #ffffff;
}
/* IE 2026 10 12 / ODOO-345618 (заказ Игоря: бейдж согласования на вкладке вместо чипса) (проба AB1): «4652/4655» шире вкладки-иконки — плотнее паддинг и интервал; наведение ширину не меняет */
.badge.badge-approval {
    padding: 1px 2px;
    letter-spacing: -0.3px;
}
/* IE 2026 10 12 / ODOO-345618 (заказ Игоря: бейдж согласования на вкладке вместо чипса): бейдж вкладки Approval при просроченных / возвращённых мне — цвет чипса status (AttrChips .status) */
.badge.badge-approval-status {
    background-color: rgba(244, 67, 54, 0.75);
    color: #ffffff;
}
.scroll-button .badge {
    top: 3px;
    right: 3px;
    background-color: #ffffff;
    color: #64efa5;
}
</style>